import React from "react";
import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
  Fab,
  Checkbox,
  // Box,
} from "@material-ui/core";
import { GetApp } from "@material-ui/icons";
import LocationOnOutlinedIcon from "@material-ui/icons/LocationOnOutlined";
import NavigationIcon from "@material-ui/icons/Navigation";
import { useStyles, placeholder } from "./SBTCard.module";
import NFT from "../../../classes/NFT/NFT";

const SBTCard = (props) => {
  const classes = useStyles();

  return (
    <Card className={classes.cardRoot}>
      <CardActionArea
        component="div"
        disableRipple
        className={classes.cardActionArea}
      >
        <div className={classes.cardLayout}>
          <div className={classes.imageCol}>
            <CardMedia
              component="img"
              alt="Carbon Credit"
              image={props.imageCarbonCredit || placeholder}
              title="Carbon Credit"
              className={classes.cardImage}
            />

            <div className={classes.retiredBadge}>RETIRED ASSET</div>

            {props.certificate == null && (
              <div className={classes.checkboxWrapper}>
                <Checkbox
                  onChange={(event) =>
                    props.handleCheckboxChange(event, props.id)
                  }
                  color="default"
                  inputProps={{ "aria-label": "checkbox with default color" }}
                  className={classes.checkbox}
                />
              </div>
            )}
          </div>

          <CardContent className={classes.contentCol}>
            <Typography className={classes.cardTitle} variant="h1">
              Carbon  Offset: 1  tonne
            </Typography>
            {/* <Typography className={classes.cardTitle} variant="h1">
              Carbon <br className={classes.onlyDesktop} />
              Offset: 1 <br className={classes.onlyDesktop} />
              tonne
            </Typography> */}

            <div
              className={classes.locationRow}
              onClick={props.toggleDrawer(true, props.id)}
              style={{ cursor: "pointer" }}
            >
              <LocationOnOutlinedIcon className={classes.locationIcon} />
              <Typography className={classes.locationText}>
                {props.name_project}
              </Typography>
            </div>

            <div className={classes.fieldGroup}>
              <Typography className={classes.fieldLabel}>ASSET CODE</Typography>
              <Typography
                className={classes.assetCode}
                onClick={props.toggleDrawer(true, props.id)}
                style={{ cursor: "pointer" }}
              >
                {props.name}
              </Typography>
            </div>

            {props.showUrls && (props.ipfsHash || props.blockchainHash) && (
              <div className={classes.fieldGroup}>
                <Typography className={classes.fieldLabel}>
                  TECHNICAL METADATA
                </Typography>
                <div className={classes.metadataBox}>
                  {props.ipfsHash && (
                    <a
                      href={props.ipfs.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={classes.metadataLink}
                    >
                      <code className={classes.metadataCode}>
                        {props.ipfsHash}
                      </code>
                    </a>
                  )}
                  {props.blockchainHash && (
                    <a
                      href={props.blockchain.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={classes.metadataLink}
                    >
                      <code className={classes.metadataCode}>
                        {props.blockchainHash}
                      </code>
                    </a>
                  )}
                </div>
              </div>
            )}

            <div className={classes.actionArea}>
              {props.certificateUrl || NFT.hasCertificate(props) ? (
                <Fab
                  variant="extended"
                  color="primary"
                  aria-label="view certificate"
                  size="large"
                  className={classes.fabBtn}
                  onClick={() =>
                    props.mostrarCertificate(
                      props.certificateUrl || props.certificate
                    )
                  }
                >
                  <span className={classes.textWrapper}>
                    {/* VIEW <br /> CERTIFICATE */}
                    VIEW  CERTIFICATE
                  </span>
                  <NavigationIcon className={classes.fabIcon} />
                </Fab>
              ) : (
                <Fab
                  variant="extended"
                  color="primary"
                  aria-label="generate certificate"
                  size="large"
                  className={classes.fabBtn}
                  onClick={props.handleGenerateCertificate}
                >
                  <span className={classes.textWrapper}>
                    GENERATE <br /> CERTIFICATE
                  </span>
                  <GetApp className={classes.fabIcon} />
                </Fab>
              )}
            </div>
          </CardContent>
        </div>
      </CardActionArea>
    </Card>
  );
};

export default SBTCard;
